module.exports = __webpack_public_path__ + "media/images/logo_sp-ebc98a26717f0a8cd4dab246b70ee5a9.png";